/*
* Project: LegalPlace assistant
* File: src/components/buy/mobile_pay_bar.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { _lp } from '../../logic/wording';
import lpevents from '../../tracking/lpevents';
import LpCreditCardModal from './card_modal';
import PaymentModal from './payment_modal';
import lpApp from '../../app/lp_app';


class _MobilePayBar extends Component {
  constructor(props) {
    super(props);
    this.showCreditCardModal = this.showCreditCardModal.bind(this);
    this.state = {
      show_modal: false,
      show_modal1: false,

    };
  }

  showCreditCardModal() {
    // Tracking opened payment popup
    const eventParams = {};

    eventParams['Chosen price'] = parseFloat(lpApp.ops.checkout.getPackPrice());
    eventParams['Total price'] = parseFloat(lpApp.ops.checkout.getTTCPrice());
    eventParams['Chosen pack'] = (this.props.choosenPack === 0) ? 'first_price' : 'second_price';
    if (lpApp.subscription && this.props.choosenPack === 1) eventParams['Chosen pack'] = 'abonnement';

    lpevents.track('Opened Payment Popup', eventParams);
    lpevents.trackPopUpCheckout()

    if (lpApp.subscription && this.props.choosenPack === 1) {
      this.setState({
        show_modal1: true,
      });
    } else this.setState({ show_modal: true });
  }


  render() {
    return (
      <div className="bottom-bar visible-xs visible-sm" ref="_one">
        <div className="bb-inner">
          <div>
            <span className="cbb-price">{_lp('Prix TTC : ')}</span>
            <span className="cbb-price is-bold">
              {lpApp.ops.checkout.getTTCPrice()}
              {' '}
€
            </span>
          </div>
          <a className="btn btn-primary cta-payement" onClick={this.showCreditCardModal}>
            <i className="icn-lock" />
            {_lp('Acheter')}
          </a>
          <div style={{ display: (this.state.show_modal || this.state.show_modal1) ? '' : 'none' }}>
            <LpCreditCardModal
              show={this.state.show_modal}
              closeEvent={() => this.setState({ show_modal: false })}
            />
            <PaymentModal
              show={this.state.show_modal1}
              closeEvent={() => this.setState({ show_modal1: false })}
            />
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  promo_code: state.checkout_operations.promo_code,
  confirmation: state.checkout_operations.confirm,
  promo_percentage: state.checkout_operations.promo_percentage,
  pack_price: state.checkout_operations.pack === 0
    ? state.checkout_operations.prices.first_price
    : state.checkout_operations.prices.second_price,
  call_chosen: state.checkout_operations.has_call,
  letter_chosen: state.checkout_operations.has_letter,
  // now with the letter informayion
  letter_number: state.checkout_operations.letter.number,
  client_email: state.account_settings.mail,
  choosenPack: state.checkout_operations.pack,
  title: state.contract.name,
  first_price: state.checkout_operations.prices.first_price,
  second_price: state.checkout_operations.prices.second_price,
});

const mapDispatchToProps = () => ({

});

const LpMobilePayBar = connect(mapStateToProps, mapDispatchToProps)(_MobilePayBar);

export default LpMobilePayBar;



// WEBPACK FOOTER //
// ./src/components/buy/mobile_pay_bar.js